require('../../../modules/es.string.includes');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').includes;